import axios from "axios";
import { gettoken } from "../token/token";
import apiurl from "../apiendpoint/apiendpoint";

export const apigetCurrentaffairById = async (id) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/apigetcurrentaffairbyid/${id}`, {headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const getAdjacentCurrentAffairs = async (id) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/api-get-adjacent-posts/${id}`, {headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};